import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";
import PropTypes from "prop-types";
import {
  tooltipContentStyle,
  tooltipItemStyle,
  tooltipLabelStyle,
  chartColors,
  defaultBarProps,
  defaultGridStyle,
} from "./ChartStyles";
import "./ComparisonBarTile.scss";

const ComparisonBarTile = ({
  title = "Revenue contribution by KA",
  subtitle = null,
  data = [],
  xKey = "name",
  series = [
    { key: "current", name: "This Year", color: chartColors.accent },
    { key: "previous", name: "Last Year", color: chartColors.primary },
  ],
  showGrid = true,
}) => {
  return (
    <div
      className="comparison-bar-tile p-4"
      style={{ width: `100%`, height: `100%` }}
    >
      <h6 className="tile-title mb-2">{title}</h6>
      {subtitle && <p className="tile-subtitle mb-3">{subtitle}</p>}

      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} isAnimationActive={false}>
          {showGrid && <CartesianGrid {...defaultGridStyle} />}
          <XAxis
            dataKey={xKey}
            tick={{ fill: "#6c757d", fontSize: "0.75rem" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: "#6c757d", fontSize: "0.75rem" }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={tooltipContentStyle}
            itemStyle={tooltipItemStyle}
            labelStyle={tooltipLabelStyle}
            formatter={(value, name) => [`${value}`, name]}
          />
          <Legend
            verticalAlign="top"
            height={20}
            iconType="circle"
            iconSize={8}
            wrapperStyle={{ fontSize: "0.75rem", color: "#6c757d" }}
          />

          {series.map((s, i) => (
            <Bar
              key={i}
              dataKey={s.key}
              name={s.name}
              fill={s.color}
              {...defaultBarProps}
              barSize={20}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

ComparisonBarTile.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  data: PropTypes.array.isRequired,
  xKey: PropTypes.string,
  series: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  showGrid: PropTypes.bool,
};

export default ComparisonBarTile;
